import { useEffect } from 'react';
import './AllProjects.scss';
import api from '../../utils/api';
import { Loader } from 'semantic-ui-react';
import { useNavigate } from "react-router";

function AllProjects() {
  const navigate = useNavigate()
  return <div className='all-projects-page'>
    Тут список всех проектов    
  </div>;
}

export default AllProjects;
